export const StatusCodes = {
    Active: "10800",
    Blocked: "10900"
}